var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 7.50136C17.5057 7.56039 15.2609 8.80623 15.2609 11.5685C15.3667 14.7188 18.0937 15.8235 18.1405 15.8235C18.0937 15.8826 17.7288 17.3285 16.6478 18.8442C15.7899 20.1498 14.8377 21.4662 13.3918 21.4662C12.0164 21.4662 11.5226 20.596 9.93562 20.596C8.23132 20.596 7.74909 21.4662 6.44422 21.4662C4.99829 21.4662 3.97555 20.0793 3.07089 18.7859C1.89559 17.0931 0.896619 14.4366 0.861352 11.8859C0.837586 10.5343 1.09672 9.20566 1.75452 8.07713C2.68295 6.50163 4.34049 5.43213 6.15059 5.39686C7.53749 5.35009 8.77182 6.34906 9.61822 6.34906C10.4294 6.34906 11.9458 5.39686 13.6616 5.39686C14.4022 5.39763 16.3772 5.62073 17.6 7.50136ZM9.50092 5.12699C9.25405 3.89266 9.93562 2.65833 10.5704 1.87096C11.3816 0.918761 12.6627 0.272461 13.7674 0.272461C13.838 1.50679 13.391 2.71736 12.5921 3.59903C11.8753 4.55123 10.641 5.26806 9.50092 5.12699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.537dcfffd13bf80fa9cd51fd1f236b6f.svg";
export { ForwardRef as ReactComponent };